import React, { Component, } from 'react'

import PropTypes from 'prop-types'
import {CCAppEventLogger, getIcon} from "./../../cc-imports";
import './cc-icon.css'
class   CCIcon extends Component {

    static propTypes = {
        onPress:PropTypes.func,
        type : PropTypes.string,
        disabled : PropTypes.bool,
        analytics:PropTypes.object,
        className:PropTypes.string,
    }

    static defaultProps = {
        onPress:()=>{},
        type : 'none',
        disabled : false,
        analytics:{},
        className:'cc-icon-xs'
    }

    constructor(props) {
        super(props)
        this.state = {}
        this._getIcon=this._getIcon.bind(this)
        this._onPress=this._onPress.bind(this)
    }

    _getIcon(){
        return getIcon(this.props.type);
    }

    _onPress(){
        const {analytics} = this.props;
        if (analytics && analytics.event) {
            const {event, params}=analytics;
            CCAppEventLogger.logAppEvent(event, params?params:{});
        }
        this.props.onPress && this.props.onPress();
    }

    render() {
        return (

            <div className={'flex-container icon-container '+ this.props.className} onClick={this._onPress}  disabled={this.props.disabled}>
                <img style={{ ...{resizeMode : 'cover'}}} src={this._getIcon()} />
            </div>


        )
    }
}

export default CCIcon


// WEBPACK FOOTER //
// ./src/app/components/CCIcon/CCIcon.js